<div class="nav-rail-content">
  <ng-content></ng-content>
</div>
